<template>
    <div class="item" v-for="item in whyList" :key="item" :style="{ backgroundImage: 'url(' + item.imgsrc + ')' }">
      <div class="text">
        <div class="title">
          <span class="number">{{ item.number }}</span>
          <span>{{ item.title }}</span>
        </div>
        <div class="description"><span>{{ item.englishTitle }}</span></div>
      </div>
      <span class="text-hover">{{ item.hoverTitle }}</span>
      <div class="bg"/>
    </div>
</template>
<script>
export default {
  name: 'WhyChooseUs',
  data () {
    return {
      whyList: [{
        title: '站式服务',
        number: '1',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/ODS/why-5.jpg',
        englishTitle: 'One-Stop Service',
        hoverTitle: '省时省力，专业高效'
      },
      {
        title: '一流人才',
        number: '100+',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/ODS/why-1.jpg',
        englishTitle: 'Over 100 Talents',
        hoverTitle: '强大的设计、研发团队'
      },
      {
        title: '方案',
        number: '1000+',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/ODS/why-2.jpg',
        englishTitle: 'Over 1000 Solutions',
        hoverTitle: '电子方案搭配海量ID设计'
      },
      {
        title: '大领域',
        number: '3',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/ODS/why-3.jpg',
        englishTitle: '3 Main Areas',
        hoverTitle: '硬件+软件+设计，一步迈入智能新生活'
      },
      {
        title: '工厂',
        number: '8000+',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/ODS/why-4.jpg',
        englishTitle: 'Over 8,000 Factories',
        hoverTitle: '众多量产配套合作伙伴'
      },
      {
        title: '天',
        number: '21',
        imgsrc: 'https://website.obs.icheer.cn/icheer-web/images/ODS/why-6.jpg',
        englishTitle: 'Only 21 Days',
        hoverTitle: '响应快，最短21天产品上市'
      }]
    }
  }
}
</script>
<style scoped>
.item{
  width: 44.3%;
  height: 21vw;
  margin: 0 .5vw .5vw 0;
  border-radius: .52vw;
  position: relative;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 105%;
  transition: background-size .5s;
  display: flex;
  justify-content: center
}

.item:focus,.item:hover {
  background-size: 160%
}

.item .text {
  z-index: 2;
  margin-top: 9vw;
  cursor: pointer;
  text-decoration: none;
  display: block;
  text-align: center
}

.item:focus .text, .item:hover .text {
  display: none
}

.item .text .number{
  z-index: 2;
  color: #0151da
}

.item .text .title{
  margin: .1vw 0 .18vw 0;
  font-size: 1.57vw;
  color: #0151da;
  font-weight: bolder;
  z-index: 2;
  display: block;
  text-align: center
}

.item .text .description{
  margin: 0 0 10vw 0;
  font-size: 1.05vw;
  z-index: 2;
  color: #696969;
  display: block;
  text-align: center
}

.item .text-hover{
  display: none
}

.item:focus .text-hover,.item:hover .text-hover{
  width: 100%;
  margin: 0 0 0 0;
  font-size: 1.35vw;
  z-index: 4;
  color: #fff;
  display: block;
  text-align: center;
  margin-top: 9vw
}

.content .item .bg{
  border-radius: .52vw;
  display: none
}

.item:focus .bg,.item:hover .bg {
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: .5;
  background-color: #0052d9;
  position: absolute;
  left: 0;
  top: 0;
  display: block
}

</style>
